




















































import { Vue, Component, Watch } from 'vue-property-decorator';
import { List } from 'vant';
import { getNewsListByCate } from './api';
import { wxShareInfo } from '@/common/ts/common';

Vue.use(List);

@Component
export default class Home extends Vue {
  activeTabIndex = 0;
  navList = [
    {
      id: 2,
      text: '直通现场',
    },
    {
      id: 3,
      text: '热点聚焦',
    },
    {
      id: 4,
      text: '三分钟聊民生',
    },
    {
      id: 5,
      text: '代表委员开箱记',
    },
    {
      id: 6,
      text: '两会圆桌',
    },
    {
      id: 7,
      text: '打虎拍蝇记',
    },
  ];
  queryArr = [
    'scene',
    'hotspot',
    'livelihood',
    'representative',
    'roundtable',
    'fighttigers',
  ];
  newsList: any[] = [];
  loading = false;
  finished = false;
  page = 1;
  error = false;

  @Watch('activeTabIndex')
  onActiveTabIndexChange(newval: number) {
    this.resetNewsList();
    this.getNewsList();
  }

  created() {
    this.getNewsList();
    this.$addPv(393);
    // 处理微信分享
    wxShareInfo({
      title: '2020加油干——重庆两会特别报道',
      subtitle: '2020加油干——重庆两会特别报道',
    });
  }
  async getNewsList() {
    if (this.finished) {
      return console.log('没有更多了');
    }
    this.loading = true;
    try {
      const ret: any = await getNewsListByCate(
        this.queryArr[this.activeTabIndex],
        {
          page: this.page,
        },
      );
      this.loading = false;
      this.newsList = [...this.newsList, ...ret.data];
      this.page++;
      console.log(ret);
      if ((!ret.data && !ret.data.length) || !ret) {
        this.finished = true;
      }
    } catch (err) {
      console.log('异常报告', err);
      this.error = true;
    }
  }
  resetNewsList() {
    this.finished = false;
    this.newsList = [];
    this.page = 1;
  }
  onNavChange(tabIndex: number) {
    this.activeTabIndex = tabIndex;
  }
  onJumpToDetail(newsItem: any) {
    if (window.udid && newsItem.dataType !== 7 && newsItem.dataType !== 5) {
      const { id, classId, isVideo } = newsItem;
      const option = {
        dt: isVideo ? 9 : 3,
        cid: classId,
        nid: id,
      };
      window.handleMessage(
        JSON.stringify({
          action: 'mJump',
          data: JSON.stringify(option),
        }),
      );
    } else {
      location.href = newsItem.targetUrl;
    }
  }
}
